export const extract = <Obj extends Record<string, any>, Keys extends (keyof Obj)[]>(
  obj: Obj,
  keys: Keys
): Pick<Obj, Keys[number]> => keys.reduce((n, v) => ({ ...n, [v]: obj[v] }), {}) as any;
